import { TokenDetailForm } from "components/TokenDetailForm"
import { RegisteredTokenDetail } from "models/factory/RegisteredTokenResponse"
import { ConfigResponse } from "models/staking/ConfigResponse"
import { TokenInfoResponse } from "models/token/TokenInfoResponse"
import { useAsset } from "provider/AssetProvider"
import { useCoinhallToken } from "provider/CoinhallTokensProvider"
import { usePagePermission } from "provider/PagePermissionProvider"
import { useWallet } from "provider/WalletProvider"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { formatAddress, fromDenom, getValidatorLogo, numberPendek } from "utils/Helpers"
import { showSimpleModal } from "utils/Modals"
import { queryValidator } from "utils/RpcHelpers"

type Props = {
    isVerified?: boolean,
    pool: number,
    tokenInfo: TokenInfoResponse,
    validatorAddress: string,
    dummyApr?: number,
    tokenAddress?: string
}

export function TokenItem({ tokenInfo, pool, validatorAddress, dummyApr, tokenAddress, isVerified = true }: Props) {
    const { address } = useWallet()
    const navigate = useNavigate()
    const [validatorInfo, setValidatorInfo] = useState<{ moniker: string, details: string, website: string, securityContact: string }>();
    const tokens = useCoinhallToken()

    const getIcon = () => {
        if (tokenAddress == "terra1a4x7t4w7a5hwqph0q0m5maqu45j99cpkgt82rllvrh4hc6g53k7spulsqj")
            return "https://i.ibb.co.com/g4BGpG9/IMG-0646.jpg"
        if (tokenAddress == "terra1x6e64es6yhauhvs3prvpdg2gkqdtfru840wgnhs935x8axr7zxkqzysuxz")
            return "https://i.ibb.co.com/Z6NmJj2/20240831-081220-0000.png"
        if (tokenAddress == "terra13y0q6dxwm3h02hqdecqy2uys7d8c4rgj34dpzwk9aa4m5jknj55s3evuu7")
            return "https://i.ibb.co.com/XkcF4yK/Whats-App-Image-2025-01-14-at-17-52-42.jpg"
        return tokens.find(e => e.id == tokenAddress)?.icon
    }


    const loadValidator = async () => {
        const res = await queryValidator(validatorAddress)
        if (res) setValidatorInfo(res.description)
    }

    useEffect(() => {
        loadValidator()
    }, [])

    return <li className="d-flex pb-1 mt-3">

        <div className="avatar flex-shrink-0 me-1">
            <img className="" src={getValidatorLogo(validatorAddress)} />
        </div>

        <div className="avatar flex-shrink-0 me-3">
            <img className="" src={getIcon()} />
        </div>

        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
            <div className="me-2">
                <h6 className="mb-0">
                    {validatorInfo?.moniker}
                    {
                        isVerified && <i onClick={() => showSimpleModal(
                            "Verified Staking Token",
                            <div className="d-flex align-items-center gap-1">
                                This token has been verified by the project owner but its not a recommendation from the platform. Stake with your own risk and always DYOR
                            </div>
                        )}
                            className="cursor-pointer bx ms-1 bx-tada-hover bx-check-shield text-success"></i>
                    }

                </h6>
                <small className="text-muted">{numberPendek(fromDenom(pool, tokenInfo.decimals))} {tokenInfo.symbol}</small>
                &nbsp;
                <small className="text-success">{dummyApr ? dummyApr * 100 : 0}% APR</small>
            </div>
        </div>
        <div className="btn-group ms-3" role="group" aria-label="Basic example">
            <button
                disabled={!address}
                onClick={() => navigate(`/hybrid-staking`)}
                type="button"
                className="btn btn-outline-primary">Stake</button>
        </div>
    </li>
}